import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from './api';
import {

    UPDATE_ORDER_STATUS,
    CANCEL_ORDER,
    COMPLETE_ORDER,
    IN_PROGRESS_ORDER,
    PENDING_ORDER,
    FETCH_ORDERS,
    VIEW_ORDER_DETAILS,
    CLOSE_DETAILS,
    UPDATE_ORDER_STATUS_SUCCESS,
    UPDATE_ORDER_STATUS_FAILURE,
    CANCEL_ORDER_SUCCESS,
    CANCEL_ORDER_FAILURE,
    COMPLETE_ORDER_SUCCESS,
    COMPLETE_ORDER_FAILURE,
    IN_PROGRESS_ORDER_SUCCESS,
    IN_PROGRESS_ORDER_FAILURE,
    PENDING_ORDER_SUCCESS,
    PENDING_ORDER_FAILURE,
    FETCH_ORDERS_SUCCESS,
    FETCH_ORDERS_FAILURE,
    VIEW_ORDER_DETAILS_SUCCESS,
    VIEW_ORDER_DETAILS_FAILURE,
} from './constant';

// Worker Sagas
function* updateOrderStatusSaga(action) {
    try {
        const response = yield call(api.updateOrderStatus, action.payload);
        yield put({ type: UPDATE_ORDER_STATUS_SUCCESS, payload: response });
    } catch (error) {
        yield put({ type: UPDATE_ORDER_STATUS_FAILURE, error });
    }
}

function* cancelOrderSaga(action) {
    try {
        const response = yield call(api.cancelOrder, action.payload);
        yield put({ type: CANCEL_ORDER_SUCCESS, payload: response });
    } catch (error) {
        yield put({ type: CANCEL_ORDER_FAILURE, error });
    }
}

function* completeOrderSaga(action) {
    try {
        const response = yield call(api.completeOrder, action.payload);
        yield put({ type: COMPLETE_ORDER_SUCCESS, payload: response });
    } catch (error) {
        yield put({ type: COMPLETE_ORDER_FAILURE, error });
    }
}

function* inProgressOrderSaga(action) {
    try {
        const response = yield call(api.inProgressOrder, action.payload);
        yield put({ type: IN_PROGRESS_ORDER_SUCCESS, payload: response });
    } catch (error) {
        yield put({ type: IN_PROGRESS_ORDER_FAILURE, error });
    }
}

function* pendingOrderSaga(action) {
    try {
        const response = yield call(api.pendingOrder, action.payload);
        yield put({ type: PENDING_ORDER_SUCCESS, payload: response });
    } catch (error) {
        yield put({ type: PENDING_ORDER_FAILURE, error });
    }
}

function* fetchOrdersSaga(action) {
    try {
        const response = yield call(api.fetchOrders, action.payload);
        yield put({ type: FETCH_ORDERS_SUCCESS, payload: response });
    } catch (error) {
        yield put({ type: FETCH_ORDERS_FAILURE, error });
    }
}

function* viewOrderDetailsSaga(action) {
    try {
        const response = yield call(api.viewOrderDetails, action.payload);
        yield put({ type: VIEW_ORDER_DETAILS_SUCCESS, payload: response });
    } catch (error) {
        yield put({ type: VIEW_ORDER_DETAILS_FAILURE, error });
    }
}

// Watcher Sagas
function* ordersSaga() {
    yield all([
        // takeLatest(UPDATE_ORDER_STATUS, updateOrderStatusSaga),
        takeLatest(CANCEL_ORDER, cancelOrderSaga),
        takeLatest(COMPLETE_ORDER, completeOrderSaga),
        takeLatest(IN_PROGRESS_ORDER, inProgressOrderSaga),
        takeLatest(PENDING_ORDER, pendingOrderSaga),
        takeLatest(FETCH_ORDERS, fetchOrdersSaga),
        takeLatest(VIEW_ORDER_DETAILS, viewOrderDetailsSaga),
        // CLOSE_DETAILS is likely a synchronous UI action, no saga needed
    ]);
}

export default ordersSaga;